import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import { LabsiteOnlineFormConfigurations } from '../../features/volunteer/models/labsiteOnlineFormConfigurations.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss'],
  standalone: false
})
export class SignaturePadComponent {

  @Output() signedData = new EventEmitter<any>();
  signaturePad!: SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  signatureImg!: string;
  @Input('FormIndex') public FormIndex!: number;
  @Input('SignPadData') public SignPadData !: LabsiteOnlineFormConfigurations;

  constructor(public translate: TranslateService) { }

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.signaturePad.clear();
  }

  clearPad() {
    this.signaturePad.clear();
  }

  captureSignedData(): string | undefined {
    if (!this.signaturePad.isEmpty()) {
      return this.signaturePad.toDataURL();
    } else {
      return undefined;
    }
  }
}